import Vue from 'vue';
import ExecutionStatus from '../../../enums/system/executionstatus';

export default Vue.component('cancelorder-modal', {
    template:`
    <div class="modal-content">
        <form @submit.prevent="cancelOrder">
            <div class="block block-rounded block-transparent mb-0">
                <div class="block-header bg-gray-lighter">
                    <h3 class="block-title">{{ resources.title }}</h3>
                </div>
                <div class="block-content">
                    <p>{{ message }}</p>
                </div>
                <div class="block-content block-content-full text-right border-top">
                    <button class="btn btn-sm btn-dual mr-1" type="button" @click="$emit('close')">{{ resources.close }}</button>
                    <button v-if="cancelAllowed" class="btn btn-sm btn-danger" type="submit"><i class="fa fa-times mr-1"></i> {{ resources.cancelOrder }}</button>
                </div>
            </div>
        </form>
    </div>
    `,
    props:{
        name: String,
        message: String,
        orderId: String,
        orderCode: String,
        cancelAllowed: Boolean,
        cutoffTimeReached: Boolean,
        resources: Object,
        axe: Function
    },
    methods:{
        cancelOrder(){
            var requestParameters = {
                orderId: this.orderId,
                orderCode: this.orderCode,
                cutoffTimeReached: this.cutoffTimeReached
            };

            this.axe.get('/cancelorder', { 
                params: { parameters: requestParameters }
            }).then((response) => { 
                if(response.data.status === ExecutionStatus.Success){
                    window.location.href = response.data.redirectUrl;
                } else {
                    this.$emit('close');
                    One.helpers('notify', { type: 'danger', icon: 'fa fa-exclamation-triangle mr-1', message: response.data.Message });
                }
            }).catch((thrown) => {
                console.log('app error', thrown.message);
            });
        }
    }
});